module.exports = __webpack_public_path__ + "img/peitoral.5ca3a031.png";